import React, { useState } from 'react'
import { useRecordContext, DeleteWithConfirmButton, useTranslate, useResourceContext } from 'react-admin'
import { userServices } from 'src/services/auth/user/user.service'

export const DisableUserButton = (props) => {
  const resource = useResourceContext()
  const record = useRecordContext()
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)

  const disableUser = async () => {
    try {
      setIsLoading(true)
      const res = userServices.disableUserById(record.id)
      setIsLoading(false)
      return res
    } catch (error) {
      setIsLoading(false)
      throw new Error('El usuario no se pudo agreagar')
    }
  }

  return (
    <DeleteWithConfirmButton
      confirmContent={translate('ra.message.delete_content')}
      disabled={isLoading}
      onClick={() => disableUser()}
      translateOptions={{
        resource: translate(`ra.single_entity.${resource}`),
        name: props.name,
      }}
    />
  )
}
